'use strict';

/**
 * @author Maxim Seredkin
 */

export default function() {
    return {
        restrict: 'A',
        template: require('../view/area-select.html'),
        transclude: true,
        scope: {
            model: '=myModel',
        },
        controller: ['$scope', 'AreaService', '$log',
                     function($scope, AreaService, $log) {
                         $scope.areas = [];
                         AreaService.api.get({
                                                 filters: [`'status' EQ 'ENABLED'`],
                                                 sorts: ['npp:ASC', 'name:ASC'],
                                             }, (data) => {
                             $scope.areas = data._embedded;
                             if ($scope.model) {
                                 $scope.model.area = $scope.areas[0];

                                 $log.debug($scope.model.area);
                             }
                         });
                     }],
    };
}
